import { STATS } from "@/data/content";

const Stats = () => {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative py-20 lg:py-28 bg-slate-900 text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 bg-dots" style={{
        backgroundImage: "radial-gradient(rgba(255,255,255,0.12) 1px, transparent 1px)",
        backgroundSize: "22px 22px",
      }} />
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-magenta/30 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-electric/30 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-10 items-end">
          <div className="lg:col-span-1">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-white/60">
              <span className="h-px w-8 bg-magenta" />
              Rezultate
            </div>
            <h2 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight">
              Cifrele vorbesc mai tare decât <span className="text-magenta">brieful</span>.
            </h2>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 lg:grid-cols-4 gap-6">
            {STATS.map((s, i) => (
              <div
                key={i}
                data-testid={`stat-${i}`}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-6"
              >
                <div
                  className="font-display text-4xl lg:text-5xl font-extrabold tracking-tighter"
                  style={{ color: s.accent === "magenta" ? "#FF49A5" : "#5E84FF" }}
                >
                  {s.value}
                </div>
                <div className="mt-2 text-sm text-white/70">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
